/*
  Shows the sticky buy bar once the real buy button has scrolled out of view, and hides it again
  when the button comes back. One IntersectionObserver, no scroll handler.

  It watches the buy-button block rather than a scroll offset, so the bar stays correct however the
  page above it changes length — a longer Taste card, a translated description, a wrapped title.
*/
(function () {
  var bar = document.querySelector('[data-rk-stickybuy]');
  if (!bar || !('IntersectionObserver' in window)) return;

  // The real thing: Dawn's product form, or the sold-out notify form when there is no form.
  var anchor = document.querySelector('.product-form__buttons') ||
               document.querySelector('product-form') ||
               document.querySelector('.rk-notify');
  if (!anchor) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      // Only hide while the anchor is visible OR still below the fold: once it is above the
      // viewport the visitor has scrolled past it, which is exactly when the bar earns its place.
      var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
      // Visibility, not the hidden attribute: `display:none` cannot transition, and a bar that
      // snaps into existence reads as a popup. `visibility:hidden` still hides it from assistive
      // tech and from the tab order.
      bar.classList.toggle('rk-stickybuy--in', passed);
    });
  }, { threshold: 0 });

  io.observe(anchor);

  // The bar's sold-out action points at the notify form further up the page; take the visitor
  // there and put the cursor in the field, so the tap completes the job rather than starting it.
  var notify = bar.querySelector('[data-rk-stickybuy-notify]');
  if (notify) {
    notify.addEventListener('click', function (e) {
      var target = document.querySelector(notify.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var field = target.querySelector('input[type="email"]');
      if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, 400);
    });
  }

  // The bar's Add to cart presses the page's real one. The bar used to post its own little form
  // (variant id + quantity 1), so a Subscribe choice made in the Appstle widget never travelled with
  // it and the sticky button always added a one-time purchase (Henry 2026-09-15). Pressing the real
  // button keeps the chosen purchase option, the variant, the cart drawer and the Sweden/Hard guard.
  var stickyForm = bar.querySelector('.rk-stickybuy__form');
  if (stickyForm) {
    stickyForm.addEventListener('submit', function (e) {
      var real = document.querySelector('#product-form-' + bar.id.replace('RkStickyBuy-', '') + ' [type="submit"][name="add"]');
      if (!real) return; // no main form on this page: the bar's own form is the only way to buy
      e.preventDefault();
      if (real.disabled || real.getAttribute('aria-disabled') === 'true') return; // busy or unavailable
      real.click();
    });
  }

  // Show the price of the option actually chosen: Appstle rewrites the main price when Subscribe is
  // picked (e.g. 25,49 instead of 29,99), so mirror that rather than always showing the one-time price.
  var priceOut = bar.querySelector('[data-rk-stickybuy-price]');
  var priceBox = document.getElementById('price-' + bar.id.replace('RkStickyBuy-', ''));
  if (priceOut && priceBox) {
    var onePrice = priceOut.textContent;
    var mirror = function () {
      var chosen = priceBox.querySelector('.appstle_subscription_final_price');
      var text = chosen ? chosen.textContent.trim() : '';
      if (priceOut.textContent !== (text || onePrice)) priceOut.textContent = text || onePrice;
    };
    new MutationObserver(mirror).observe(priceBox, { childList: true, subtree: true, characterData: true });
    mirror();
  }

  // Dawn re-renders the buy buttons on a variant change, which detaches the observed node.
  var mo = new MutationObserver(function () {
    var fresh = document.querySelector('.product-form__buttons') || document.querySelector('product-form');
    if (fresh && fresh !== anchor) { io.unobserve(anchor); anchor = fresh; io.observe(anchor); }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
